<template>

  <div class='chart-wrapper'>
    <div class="groupedbarchart">
      <div ref="chart" class = "groupedbarcharttarget"></div>
    </div>

  </div>

</template>



<script>

	import groupedBar from '@/charts/grouped-bar'



  //this is an example of the data that we get delivered from the server
  const delivered_data = [
    {
        "groupName": "this_month",
        "color": "#e16628",
        "data": [
            {
                "date": "2019-04-01T00:00:00Z",
                "label": "volume",
                "value": 37277,
                "value_type": "number"
            },
            {
                "date": "2019-04-01T00:00:00Z",
                "label": "tow_volume",
                "value": 16472,
                "value_type": "number"
            },
            {
                "date": "2019-04-01T00:00:00Z",
                "label": "cancelled_freq",
                "value": 0.0320676237756608,
                "value_type": "percentage"
            }
        ]
    },
    {
        "groupName": "prev_month",
        "color": "#9ecae1",
        "data": [
            {
                "date": "2019-03-01T00:00:00Z",
                "label": "volume",
                "value": 39029,
                "value_type": "number"
            },
            {
                "date": "2019-03-01T00:00:00Z",
                "label": "tow_volume",
                "value": 16630,
                "value_type": "number"
            },
            {
                "date": "2019-03-01T00:00:00Z",
                "label": "cancelled_freq",
                "value": 0.0293145419602819,
                "value_type": "percentage"
            }
        ]
    }
]


  //this is an example of what the chart expects. except that "metric" has been changed to "label"
	const fakedata = [
  {
		"group": "Feb 2019",
		"metric": "Driver called Member",
		"metric_slug": "cmtrk_mean",
		"chart": "kmi",
		"color": "#9ecae1",
		"value": 38.6
	}, {
		"group": "Feb 2019",
		"metric": "Service Provider Called Member",
		"metric_slug": "cmspp_mean",
		"chart": "kmi",
		"color": "#c6dbef",
		"value": 6.5
	}, {
		"group": "Feb 2019",
		"metric": "Dispatch Called Member",
		"metric_slug": "cmdispatch_mean",
		"chart": "kmi",
		"color": "#fdd0a2",
		"value": 14.9
	}, {
		"group": "Feb 2019",
		"metric": "Text Message",
		"metric_slug": "kmi_text_mean",
		"chart": "kmi",
		"color": "#fd8d3c",
		"value": 70.3
	}, {
		"group": "Feb 2019",
		"metric": "Auto Call Out Dispatch",
		"metric_slug": "codispatch_mean",
		"chart": "kmi",
		"color": "#fdae6b",
		"value": 12
	}, {
		"group": "Feb 2019",
		"metric": "Auto Call Out Field",
		"metric_slug": "coext_mean",
		"chart": "kmi",
		"color": "#6baed6",
		"value": 89.3
	}]



  const prep_data = (data) => {
		const result = [];

		data.forEach((group) => {

			group.data.forEach((d) => {
				d.group = group.groupName;
				result.push(d);
      })
    })

    return result;
  }

	export default {
		name: "GroupedBar",
    props: ["data"],
    data: function() {
			return {
				chart: null
      }
    },
		methods: {
			drawBar: function () {
				const _t = this;
				return new groupedBar({
					data: this.formatted_data,
					bindTo: this.$refs.chart,
          bindLegendTo: this.$refs.legend,
				});
			}
		},
    computed: {
			formatted_data: function() {
				return prep_data(this.data)
      }
    },
    watch: {
			formatted_data: function() {
				console.log("Updating the new target data, my bitches!!")
        console.log(this.formatted_data)
				this.chart.update(this.formatted_data);
      }
    },
		mounted() {
			this.chart = this.drawBar();
		}
	}

</script>


<style lang="less">

  .grouped-bar-chart {
    margin: 1em auto;
    display: flex;
    align-items: center;
  }



  /* for legend. Classes generated by chart javascript */

  .notarget .target {
    opacity: 0;
    -webkit-transition: opacity .4s ease-in-out;
    -moz-transition: opacity .4s ease-in-out;
    -ms-transition: opacity .4s ease-in-out;
  }

  .legend-item-wrapper {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    flex-flow: row wrap;
    max-width: 400px;
    margin: 0 auto;
    overflow-x: auto;

  }

  .barchartlegenditem {
    display: flex;
    flex-wrap: nowrap;
    font-family: sans-serif;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 12px;
    padding: 0 10px;
    cursor: pointer;
    margin: .08em 0;
    width: 200px;
    height: 20px;
    overflow: hidden;

  }

  .barchartlegenditem svg {
    margin-top: 6px;
  }

  .barchartlegenditem .label {
    margin-left: 1em;
    white-space: nowrap;
    font-size: 13px;
    overflow-x: visible;
    width: 1px;

  }

  .barchartlegenditem.notactive {
    opacity: .4;
  }

  .barchartlegenditem.barfocus {
    font-weight: bold;
  }

  /*rect.barfocus {*/
  /*stroke: ;*/
  /*}*/

  .legend-header {
    font-family: sans-serif;
    font-size: 15px;
    font-weight: bolder;
    margin: .8em auto;
    text-align: start;
    padding-left: 1.5em;
  }

  .grouped-bar .tick text {
    font-size: 12px;
  }

  .grouped-bar .x .tick text {
    font-weight: bold;
    color: #10315E;
    font-size: 13px;
  }

  .bar text {
    font-size: 12px;
  }

  /* comparative bar specific */

  .bar-chart-legend {
    /*width, but not max-width, same as chart*/
    padding: 0 .7em;
    margin: 0 auto;

  }

  /*#ata-pta-bar-legend */
  .bar-chart-legend {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-evenly;
  }

  .legend-section-wrapper {
    /*display: flex;*/
    /*flex-flow: column nowrap;*/
    margin: 0 auto;
    max-width: 400px;

  }

  #ata-pta-bar-legend .legend-section-wrapper {
    width: 200px;
  }

</style>
